var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCard2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Activate-card",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrative-/-Bills",
    transform: "translate(4.000000, 11.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6680219,23.731758 C39.6680219,24.6533005 38.9140326,25.4072899 37.99249,25.4072899 L1.98824136,25.4072899 C1.0666988,25.4072899 0.312709441,24.6533005 0.312709441,23.731758 L0.312709441,2.30044814 C0.312709441,1.37890559 1.0666988,0.624916223 1.98824136,0.624916223 L37.99249,0.624916223 C38.9140326,0.624916223 39.6680219,1.37890559 39.6680219,2.30044814 L39.6680219,23.731758 Z M21.7436004,6.00224269 L34.8362068,6.00224269 M30.7058112,19.9517161 L34.8359973,19.9517161 L34.8359973,15.8215299 L30.7058112,15.8215299 L30.7058112,19.9517161 Z M10.1449402,17.9355066 L12.7260971,17.9355066 M15.3110239,17.9355066 L17.8925997,17.9355066 M20.4771496,17.9355066 L23.0587254,17.9355066 M4.97847939,17.9355066 L7.56005519,17.9355066",
    id: "Icon"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard2);
export default __webpack_public_path__ + "static/media/icon-card2.254b53b2.svg";
export { ForwardRef as ReactComponent };